// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { Component, Input, OnInit } from '@angular/core';
import { RepoDetail } from '@models';
import { FlyoutService } from '@services';

interface PlatformGroup {
  platform: string;
  icon: string;
  repos: RepoDetail[];
}

@Component({
  selector: 'lfx-repository-details-offcanvas',
  templateUrl: './repository-details-offcanvas.component.html',
  styleUrls: [
    '../base-list-offcanvas/base-list-offcanvas.component.scss',
    './repository-details-offcanvas.component.scss',
  ],
  standalone: false,
})
export class RepositoryDetailsOffcanvasComponent implements OnInit {
  @Input() details: RepoDetail[] = [];

  platformIcons = {
    github: 'assets/img/svgs/platforms/github.svg',
    gitlab: 'assets/img/svgs/platforms/gitlab.svg',
    gerrit: 'assets/img/svgs/platforms/gerrit.svg',
    git: 'assets/img/svgs/platforms/git.svg',
  };

  defaultPlatformIcon = 'assets/img/fa-code.svg';

  platformGroups: PlatformGroup[] = [];

  constructor(private flyoutService: FlyoutService) {}

  ngOnInit(): void {
    this.platformGroups = this.getPlatformGroups();

    const allSameLength = this.platformGroups.every(
      group => group.repos.length === this.platformGroups[0].repos.length
    );

    if (allSameLength) {
      const platformOrder = ['github', 'git', 'gitlab', 'gerrit'];

      this.platformGroups.sort(
        (a, b) =>
          platformOrder.indexOf(a.platform) - platformOrder.indexOf(b.platform)
      );
    } else {
      this.platformGroups.sort((a, b) => b.repos.length - a.repos.length);
    }
  }

  getPlatformGroups(): PlatformGroup[] {
    const groups = this.details.reduce(
      (acc, repo) => {
        const platform = repo.platform.trim().toLowerCase();

        if (!acc[platform]) {
          acc[platform] = [];
        }
        acc[platform].push(repo);

        return acc;
      },
      {
        github: [],
        gitlab: [],
        gerrit: [],
        git: [],
      } as Record<string, RepoDetail[]>
    );

    return Object.entries(groups).map(([platform, repos]) => ({
      platform,
      icon:
        this.platformIcons[platform.trim().toLowerCase()] ||
        this.defaultPlatformIcon,
      repos,
    }));
  }

  close(): void {
    this.flyoutService.close();
  }
}
